export default __webpack_public_path__ + "static/media/pro-elevate-wht-banner-1.085c295f.jpg";